import React from 'react'
import { Button } from '../../common'

interface ResourceSectionProps {
  title: string
  actionButton?: {
    text: string
    onClick: () => void
    variant?: 'primary' | 'download',
    icon?: React.ReactNode
  }
  children: React.ReactNode
}

const ResourceSection: React.FC<ResourceSectionProps> = ({
  title,
  actionButton,
  children
}) => {

  return (
    <div className="resource-section">
      <div className="box md">
        <div className="section-header">
          <h2>{title}</h2>
          {actionButton && (
            <Button
              className="primary sm"
              onClick={actionButton.onClick}
            >
              <span className="flex items-center gap-1">
                {actionButton.text}
                {actionButton.icon && <span className="icon">{actionButton.icon}</span>}
              </span>
            </Button>
          )}
        </div>
        {children}
      </div>
    </div>
  )
}

export default ResourceSection
